import { gql } from '@apollo/client';

export const fetchListsCreators = gql`
  query getListCreators {
    emailListsCreators {
      id
      fullName
      avatarUrl
    }
  }
`;
